<script setup lang="ts">
  import { computed } from 'vue';
  import {
    descriptionClass,
    dividerClass,
    headerClass,
    sectionClass,
    titleClass,
    titleSmallClass,
  } from './FormSection.css';
  import type { FormSectionProps } from './FormSection.types';
  import { FormSectionTitleSize } from './FormSection.types';

  const props = withDefaults(defineProps<FormSectionProps>(), {
    titleSize: FormSectionTitleSize.Md,
    hideDivider: false,
  });

  const resolvedTestId = computed(() => props.testId ?? 'ds-form-section');

  const isSmallTitle = computed(
    () => props.titleSize === FormSectionTitleSize.Sm,
  );

  const sectionClasses = computed(() => [
    sectionClass,
    !props.hideDivider && dividerClass,
  ]);

  const titleClasses = computed(() => [
    titleClass,
    isSmallTitle.value && titleSmallClass,
  ]);
</script>

<template>
  <section :class="sectionClasses" :data-testid="resolvedTestId">
    <div v-if="title || description" :class="headerClass">
      <h3 v-if="title && isSmallTitle" :class="titleClasses">{{ title }}</h3>
      <h2 v-else-if="title" :class="titleClasses">{{ title }}</h2>
      <p v-if="description" :class="descriptionClass">{{ description }}</p>
    </div>

    <slot />
  </section>
</template>
